var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn--primary px-4 ml-3",attrs:{"type":"button"},on:{"click":_vm.openAddProviderModal}},[_vm._v(" Add Provider ")]),_c('AddProviderModal',{attrs:{"id":'addProvider',"closeModal":_vm.closeModal,"refetch":_vm.refetch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }